<template>
  <div>
    <PageTitle
      title="Bank Book"
      :btnCreate="false"
      :permission="'Customer Create'"
    />
    <v-container
      fluid
      class="lighten-12 content"
      style="background-color: white"
    >
      <AccountSelection
        @selectedBankAccount="setselectedBankAccount"
        ref="getaccount"
        v-show="!accountSelectionVisible"
      />
      <v-card class="lighten-12 card-content" v-show="accountSelectionVisible">
        <div v-if="isShopSelected">
          <span class="shopAlert"> Shop is required</span>
        </div>
        <TableFilters
          :filters="[
            'dateRangebook',
            'shop',
            'backbutton',
            'search',
            'dateRange1',
          ]"
          v-model="filter"
          @updateBackButton="updateBackButton"
          :ShopVisible="true"
          :columns="false"
          :hasDate="true"
          :balance="totalBalance"
          :changingBalance="rangeBalance"
          :filteredBalance="'Filtered Date Balance'"
          :filteredDate="'Filtered Date Range'"
        >
        </TableFilters>
      </v-card>
      <ValidationObserver
        ref="observer"
        v-slot="{ validate, reset }"
        v-show="accountSelectionVisible"
      >
        <v-card class="lighten-12 mt-2">
          <v-container fluid class="light gray lighten-12">
            <v-row v-if="editId == null">
              <v-col cols="6" sm="6" lg="2">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="Types"
                >
                  <v-autocomplete
                    hide-details="auto"
                    :error-messages="errors"
                    required
                    :items="types"
                    v-model="bankbook.type"
                    item-text="text"
                    item-value="value"
                    label="Type"
                    outlined
                    clearable
                    dense
                  ></v-autocomplete> </ValidationProvider
              ></v-col>
              <v-col cols="6" sm="6" lg="2">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Amount"
                  vid="sortform"
                  rules="required"
                >
                  <v-text-field
                    :error-messages="errors"
                    required
                    dense
                    label="Amount"
                    v-model="bankbook.amount"
                    outlined
                  ></v-text-field> </ValidationProvider
              ></v-col>
              <v-col cols="6" sm="6" lg="4">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Comments"
                  vid="sortform"
                  rules="required"
                >
                  <v-text-field
                    :error-messages="errors"
                    required
                    dense
                    label="Comments"
                    v-model="bankbook.explanation"
                    outlined
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="1">
                <permission-control permissionName="Unit Create">
                  <v-btn
                    @click="SaveUnit()"
                    depressed
                    :disabled="isDisabled"
                    small
                    class="text-white btn_blue btn_medium w-100"
                    >Create</v-btn
                  >
                </permission-control></v-col
              >
              <v-col
                cols="6"
                sm="6"
                lg="1"
                style="padding: 12px 20px 12px 43px"
              >
                <v-btn
                  @click="exportPDF()"
                  depressed
                  small
                  :disabled="isDisabled"
                  class="text-white btn_medium w-100"
                  color="red"
                >
                  <v-icon small>mdi-file-pdf-box</v-icon>PDF</v-btn
                >
              </v-col>
              <v-col
                cols="6"
                sm="6"
                lg="1"
                style="padding: 12px 20px 12px 60px"
              >
                <v-btn
                  @click="exportExcel()"
                  depressed
                  small
                  :disabled="isDisabled"
                  class="text-white btn_medium w-100"
                  color="green"
                  ><v-icon small>mdi-file-excel </v-icon>Excel</v-btn
                ></v-col
              >
            </v-row>

            <v-data-table
              :items-per-page="150"
              fixed-header
              :headers="columns"
              :items="ChequeData"
              item-key="id"
              hide-default-footer
              height="400px"
              id="indextable"
            >
              <template v-slot:no-data>
                <img
                  style="height: 200px"
                  src="../../../assets/img/no-result.jpg"
                />
              </template>
              <!-- No -->
              <template v-slot:item.no>
                <v-icon>mdi-vuetify</v-icon>
              </template>
              <!-- Reference No -->
              <template v-slot:item.reference_number="{ item }">
                <p>{{ item.reference_number }}</p>
              </template>

              <template v-slot:item.bank="{ item }">
                <p>{{ item.bank.name }}</p>
              </template>

              <!-- bank -->
              <template v-slot:item.bank.name="{ item }">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Type"
                  v-if="item.id == editId"
                  rules="required"
                >
                  <v-autocomplete
                    hide-details="auto"
                    :error-messages="errors"
                    required
                    :items="BanksData"
                    class="inputareatext"
                    v-model="bankbooksingledata.bank.id"
                    item-text="name"
                    item-value="id"
                    label="Type"
                    outlined
                    clearable
                    dense
                  ></v-autocomplete>
                </ValidationProvider>
                <p v-else>{{ item.bank.name }}</p>
              </template>

              <!-- Date -->
              <template v-slot:item.date="{ item }">
                <p>{{ item.date | formatDate }}</p>
              </template>
              <!-- Explanation -->
              <template v-slot:item.explanation="{ item }">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Explanation"
                  v-if="item.id == editId"
                  rules="required"
                >
                  <v-text-field
                    v-if="item.id == editId"
                    :error-messages="errors"
                    v-model="bankbooksingledata.explanation"
                    :value="item.explanation"
                    outlined
                    class="inputareatext"
                  ></v-text-field>
                </ValidationProvider>
                <p v-else>{{ item.explanation }}</p>
              </template>
              <!-- Amount -->
              <template v-slot:item.amount="{ item }">
                <ValidationProvider
                  v-slot="{ errors }"
                  name="amount"
                  v-if="item.id == editId"
                  rules="required"
                >
                  <v-text-field
                    v-if="item.id == editId"
                    :error-messages="errors"
                    class="inputareatext"
                    v-model="bankbooksingledata.amount"
                    :value="item.amount"
                    outlined
                  ></v-text-field>
                </ValidationProvider>
                <p v-else>
                  {{ item.amount }}

                  <v-icon
                    v-if="item.type == 'Deposit'"
                    style="color: green"
                    class="icon_large"
                    v-bind="$attrs"
                    v-on="on"
                    >mdi-plus-box</v-icon
                  >
                  <v-icon
                    v-else
                    style="color: red"
                    class="icon_large"
                    v-bind="$attrs"
                    v-on="on"
                    >mdi-minus-box</v-icon
                  >
                </p>
              </template>

              <!-- Balnce -->
              <template v-slot:item.balance="{ item }">
                <p>
                  {{ item.balance }}
                  <v-icon
                    v-if="item.balance > 0"
                    style="color: green"
                    class="icon_large"
                    v-bind="$attrs"
                    v-on="on"
                    >mdi-plus-box</v-icon
                  >
                  <v-icon
                    v-else
                    style="color: red"
                    class="icon_large"
                    v-bind="$attrs"
                    v-on="on"
                    >mdi-minus-box</v-icon
                  >
                </p>
              </template>

              <!-- Action -->
              <template v-slot:item.action="{ item }">
                <v-menu offset-y transition="scroll-y-transition">
                  <template v-slot:activator="{ $attrs, on }">
                    <v-icon v-show="editId != item.id" v-bind="$attrs" v-on="on"
                      >mdi-dots-vertical</v-icon
                    >
                    <v-btn
                      v-show="editId == item.id"
                      color="secondary"
                      fab
                      x-small
                      dark
                      class="ma-1"
                    >
                      <v-icon depressed small link @click="CancelUnit(item)"
                        >clear</v-icon
                      ></v-btn
                    >
                    <v-btn
                      v-show="editId == item.id"
                      color="green"
                      fab
                      x-small
                      dark
                      ><v-icon link @click="UpdateBankBook(item)"
                        >done</v-icon
                      ></v-btn
                    >
                  </template>

                  <v-list class="actions">
                    <permission-control permissionName="Unit Edit">
                      <v-list-item
                        link
                        @click="EditChequeBook(item)"
                        :disabled="isDisabled"
                      >
                        <span>
                          <v-icon v-bind="$attrs" v-on="on"
                            >mdi-pencil-box-outline</v-icon
                          >Edit
                        </span>
                      </v-list-item>
                    </permission-control>
                  </v-list>
                </v-menu>
              </template>

              <template v-slot:footer>
                <pagination
                  @paginationOptions="setPaginationOptions"
                  @responseDataBank="receivebankbookDatas"
                  @responseDataBalance="GetBalanceAmount"
                  @getPageNumber="setPagenumber"
                  :filterAction="true"
                  :url="`bank-books/bank-account/${bank_accountId}`"
                  :filter="filter"
                  ref="pagination"
                />
              </template>
            </v-data-table>
          </v-container>
        </v-card>
      </ValidationObserver>
    </v-container>
  </div>
</template>

<script>
import DatePicker from '@/components/base/DateComponent.vue';
import AccountSelection from './AccountSelection.vue';

import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
import { required, regex } from 'vee-validate/dist/rules';
import { DateTime } from '@grapecity/wijmo';
import jsPDF from 'jspdf';
import _ from 'lodash';
import XLSX from 'xlsx';
extend('required', {
  ...required,
  message: '{_field_} is required',
});
extend('regex', {
  ...regex,
  message: 'The value is not a valid Amount',
});
import pagination from '../../shared/components/pagination';
import TableFilters from '@/components/base/TableFilters';
import ChequeBook from '../../../models/chequeBook';
import * as moment from 'moment/moment';

export default {
  data: () => ({
    ChequeData: [],
    on: {
      click: console.log,
      contextmenu: console.log,
    },
    inheritAttrs: false,
    accountSelectionVisible: false,
    isShopSelected: false,
    bankbooksingledata: [],
    BanksData: [],
    ShopId: null,
    bank_accountId: null,
    bank_Id: null,
    balance: null,
    bankbook: new ChequeBook(),
    paginationOptions: {},
    VisibleCreate: false,
    isDisabled: false,
    EditVisible: false,
    WareHouses: [],
    rangeBalance: 0,
    totalBalance: 0,
    columns: [
      {
        text: 'Reference Number',
        value: 'reference_number',
        show: true,
        disabled: false,
        align: 'left',
      },
      {
        text: 'Date',
        value: 'date',
        show: true,
        disabled: false,
        align: 'left',
      },
      {
        text: 'Bank',
        value: 'bank',
        show: true,
        disabled: false,
        align: 'left',
      },

      {
        text: 'Comments',
        value: 'explanation',
        show: true,
        disabled: false,
        align: 'left',
      },
      {
        text: 'Amount',
        value: 'amount',
        show: true,
        disabled: false,
        align: 'right',
      },
      {
        text: 'Balance',
        value: 'balance',
        show: true,
        disabled: false,
        align: 'right',
      },

      {
        text: 'Actions',
        value: 'action',
        width: '9%',
        show: true,
        disabled: false,
        align: 'center',
      },
    ],
    types: [
      { text: 'Deposit', value: 'Deposit' },
      { text: 'Withdrawal', value: 'Withdrawal' },
    ],
    cash_book_for: [
      { text: 'Warehouse', value: 'Warehouse' },
      { text: 'Shop', value: 'Shop' },
    ],
    editId: null,
    filter: {
      search: '',
      shop: 1,
      startDate: moment(new Date()).format('YYYY-MM-DD'),
      end: '',
    },
    bankbook: {
      explanation: '',
      type: '',
      amount: 0,
    },
    selectionData: [],
    wareHouseLabel: '',
    balances: 0,
  }),
  components: {
    TableFilters,
    ValidationProvider,
    ValidationObserver,
    pagination,
    DatePicker,
    AccountSelection,
  },

  methods: {
    CancelUnit(item) {
      this.refreshData();
      this.editId = null;
    },
    //Get BanksData Data
    setselectedBankAccount(data) {
      this.bank_accountId = data.id;
      this.bank_Id = data.bank_id;
      this.accountSelectionVisible = true;
      setTimeout(() => {
        this.refreshData();
      }, 60);
    },
    setPagenumber(event) {
      this.$router.push('?page=' + event);
      this.$store.dispatch('SetProductSize', event);
    },
    //Get Pagination Datas
    setPaginationOptions(data) {
      this.paginationOptions = data;
    },

    SaveUnit() {
      const isValid = this.$refs.observer.validate();

      if (isValid) {
        this.CreateBankbook();
      }
    },

    refreshData() {
      this.$refs.pagination.refreshData();
    },

    sumField(array, type, field) {
      let value = 0;
      array.forEach((element) => {
        if (element[type] == 'Deposit') {
          value += parseFloat(element[field]);
        } else {
          value -= parseFloat(element[field]);
        }
      });
      return value;
    },

    // Get All BankBook Data With Paginated
    receivebankbookDatas(data) {
      let totalDeposit = 0;
      let totalWithdrawal = 0;
      this.ChequeData = data;
      this.ChequeData.forEach((element) => {
        const amount = parseFloat(element?.amount) || 0;

        if (element.type === 'Withdrawal') {
          totalWithdrawal += amount;
        } else {
          totalDeposit += amount;
        }
      });

      let dataLength = this.ChequeData.length;
      this.totalBalance = this.ChequeData?.[dataLength - 1]?.totalBalance;
      this.rangeBalance = totalDeposit - totalWithdrawal;
    },

    // Get All BankBook Balance
    GetBalanceAmount(data) {
      this.balance = data;
    },

    //Update BankBook
    async UpdateBankBook(item) {
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        let Credential = this.bankbooksingledata;
        Credential.shop_id = this.bankbooksingledata.shop.id;
        Credential.bank_account_id = this.bank_accountId;
        Credential.bank_id = this.bank_Id;
        this.isDisabled = true;
        this.$store
          .dispatch(`book/EditBankbook`, Credential)
          .then((res) => {
            this.editId = null;
            this.$toast.success('Bank book edited successfully');
            this.isDisabled = false;
            this.$refs.getaccount.callingRefresh();

            this.refreshData();
            this.VisibleCreate = false;
            this.$refs.observer.reset();
            this.bankbooksingledata = [];
          })
          .catch((err) => {
            this.$toast.error('Failed to edit bank book.');
            this.isDisabled = false;
          });
      }
    },

    //edit BankBook
    EditChequeBook(item) {
      this.VisibleCreate = true;
      this.EditVisible = true;

      this.editId = item.id;

      this.$store
        .dispatch(`book/getSinglebankbook`, item.id)
        .then((res) => {
          this.bankbooksingledata = res.data;
          this.$refs.getaccount.callingRefresh();
        })
        .catch((err) => {});
    },

    //Create BankBook
    async CreateBankbook() {
      let self = this;

      let credential = self.bankbook;
      credential.shop_id = self.filter.shop;
      credential.bank_account_id = this.bank_accountId;
      credential.bank_id = this.bank_Id;
      if (!this.filter.shop) {
        this.isShopSelected = true;
      } else {
        this.isShopSelected = false;

        let self = this;
        let credential = self.bankbook;
        credential.shop_id = self.filter.shop;
        credential.bank_account_id = this.bank_accountId;
        credential.bank_id = this.bank_Id;

        credential.date = self.filter.startDate;

        this.isDisabled = true;

        this.$store
          .dispatch(`book/CreateBankbook`, credential)
          .then((res) => {
            this.$toast.success('Bank book created successfully');
            this.isDisabled = false;

            this.refreshData();
            this.$refs.observer.reset();
            this.bankbook = new ChequeBook();
          })
          .catch((err) => {
            this.isDisabled = false;

            this.$toast.error('Bank book created failed');
          });
      }
    },

    updateBackButton() {
      setTimeout(() => {
        this.accountSelectionVisible = false;
      }, 40);

      this.$refs.getaccount.callingRefresh();
    },
    //Get BanksData Data
    getBanksDataData() {
      this.$store
        .dispatch(`shop/getBankDetails`)
        .then((res) => {
          this.BanksData = res.data.data;
        })
        .catch((err) => {});
    },
    exportPDF() {
      let Data = _.cloneDeep(this.ChequeData);
      for (let x = 0; x < Data.length; x++) {
        Data[x].bank = Data[x].bank.name;
        Data[x].date = moment(Data[x].date).format('DD/MM/YYYY');
      }
      var rows = Data;
      var doc = jsPDF({
        orientation: 'landscape',
      });
      doc.setFontSize(14);
      doc.setTextColor(26, 26, 26);
      doc.setFont('helvetica', 'bold');
      doc.text('Bank Book Report', 15, 5);

      doc.setFontSize(11);
      doc.text(15, 12, `${moment(today).format('DD-MM-YYYY HH:MM:SS')}`);

      doc.autoTable(
        this.columns.map((h) => {
          if (h.text == 'Actions') {
            delete { title: h.text, dataKey: h.value };
          } else {
            return { title: h.text, dataKey: h.value };
          }
        }),
        rows,
        {
          didParseCell: function (data) {
            if (data.column.dataKey === 'addsress') {
              data.cell.text = data.cell.raw.country;
            }
          },
        },
      );
      const today = new DateTime();
      doc.save(`${moment(today).format('DD-MM-YYYY')}-Bank-Book.pdf`);
    },
    exportExcel() {
      var data = document.getElementById('indextable');
      const today = new DateTime();
      const headData = XLSX.utils.table_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(
        wb,
        headData,
        moment(today).format('DD-MM-YYYY'),
      );
      XLSX.writeFile(
        wb,
        `${moment(today).format('DD-MM-YYYY')}-Cash-Book.xlsx`,
      );
    },
  },
  created() {
    this.getBanksDataData();
  },

  computed: {},
};
</script>
<style scoped>
#indextable {
  max-height: 400px;
  overflow: auto;
}
.Balancebox {
  background: #ebf2ff;
  width: auto;
  color: #000000d4;
  align-items: center;
  text-align: center;
  height: 35px;
  margin-right: 0;
  border-radius: 6px;
}
.Balancebox2 {
  background: #ffebeb;
  width: auto;
  color: red;
  align-items: center;
  text-align: center;
  height: 35px;
  margin-right: 0;
  border-radius: 6px;
}
.createButton {
  height: 28px !important;
  width: 56px !important;
  margin: 8px;
  border-radius: 16px;
  background: #8796de !important;
  color: white;
  border: none;

  outline: none;
}
.EditButton {
  height: 28px !important;
  width: 56px !important;
  margin: 8px;
  border-radius: 16px;
  background: green !important;
  color: white;
  border: none;
  outline: none;
}
.UpdateButton {
  height: 28px !important;
  width: 56px !important;
  margin: 8px;
  border: none;
  outline: none;

  border-radius: 16px;
  background: purple !important;
  color: white;
}
.table-responsive {
  white-space: nowrap;
}

.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

div.table-responsive > div.dataTables_wrapper > div.row {
  margin: 0;
}

div.dataTables_wrapper div.dataTables_length label {
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
}

label {
  display: inline-block;
  margin-bottom: 0.5rem;
}

div.dataTables_wrapper div.dataTables_length select {
  width: auto;
  display: inline-block;
}

div.table-responsive
  > div.dataTables_wrapper
  > div.row
  > div[class^='col-']:last-child {
  padding-right: 0;
}

div.table-responsive > div.dataTables_wrapper > div.row {
  margin: 0;
}

div.table-responsive
  > div.dataTables_wrapper
  > div.row
  > div[class^='col-']:last-child {
  padding-right: 0;
}

div.table-responsive
  > div.dataTables_wrapper
  > div.row
  > div[class^='col-']:first-child {
  padding-left: 0;
}

th {
  background: #feffff !important;
}

table.dataTable {
  clear: both;
  margin-top: 6px !important;
  margin-bottom: 6px !important;
  max-width: none !important;

  border-spacing: 0;
}

.table {
  color: #333;
  max-width: 100%;
  margin-bottom: 0;
  width: 100%;
}

.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
}

.table thead {
  background-color: #f8f9fa;
  border-bottom: 0px solid rgba(0, 0, 0, 0.03);
}

tr {
  display: table-row;

  border-color: inherit;
}

table.dataTable thead > tr > th.sorting_asc {
  padding-right: 30px;
  cursor: pointer;
  position: relative;
}

.table.table-center th {
}

.table thead tr th {
  font-weight: 600;
  border: 0;
}

table.dataTable th {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}

.table thead th {
  vertical-align: bottom;
  border-bottom: 0px solid #dee2e6;
}

table.dataTable thead > tr > th.sorting {
  padding-right: 30px;
  cursor: pointer;
  position: relative;
}

.table thead tr th {
  font-weight: 600;
  border: 0;
}

table.dataTable th {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}

.table th {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 0px solid #dee2e6;
}

th {
  text-align: inherit;
}

.table tbody tr {
  border-bottom: 0px solid rgba(0, 0, 0, 0.05);
}

table.table td h2.table-avatar {
  align-items: center;
  display: inline-flex;
  font-size: inherit;
  font-weight: 400;
  margin: 0;
  padding: 0;

  white-space: nowrap;
}

table.table td h2 {
  display: inline-block;
  font-size: inherit;
  font-weight: 400;
  margin: 0;
  padding: 0;
}

h2 {
  font-family: 'Mada', sans-serif;
  margin-top: 0;
}

h2 {
  font-size: 2rem;
}

table.dataTable td {
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}

.table td {
  padding: 0.05rem;

  border-top: 0px solid #dee2e6;
}

table.table td h2.table-avatar {
  align-items: center;
  display: inline-flex;
  font-size: inherit;
  font-weight: 400;
  margin: 0;
  padding: 0;

  white-space: nowrap;
}

.inputareatext {
  width: 180px;
}

.shopAlert {
  color: red;
}
</style>
